import React, { useState } from 'react';
import { createAutomaticQuote } from '../../util/api';
import { NamedLink } from '../../components';
import css from '../commercial/phase3.module.css';

/**
 * Automatic quotation for a catalogue listing that was created from a Mongo product.
 */
const GetAutomaticQuote = ({ currentUser, publicData }) => {
  const productId = publicData?.mongoProductId;
  const [quantity, setQuantity] = useState(publicData?.moq || '');
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (!productId) return null;

  const submit = async () => {
    if (!currentUser?.id?.uuid) {
      setError('Sign in to generate a quotation.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const data = await createAutomaticQuote({
        buyerUserId: currentUser.id.uuid,
        buyerName: currentUser.attributes?.profile?.displayName || '',
        productId,
        quantity: Number(quantity),
      });
      setQuote(data.quote);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className={css.quoteBox}>
      <h2>Get a quotation</h2>
      <p className={css.meta}>Enter a quantity at or above the minimum order. Pricing is calculated on the server and saved as a snapshot.</p>
      <label className={css.label}>
        Quantity ({publicData.unitOfMeasurement || 'pcs'})
        <input className={css.input} type="number" min="1" value={quantity} onChange={e => setQuantity(e.target.value)} />
      </label>
      <div className={css.actions}>
        <button className={css.btnPrimary} type="button" onClick={submit} disabled={busy}>{busy ? 'Calculating…' : 'Get automatic quote'}</button>
        <NamedLink className={css.btnQuiet} name="RfqPage">Request custom quote</NamedLink>
      </div>
      {error && <div className={css.err}>{error}</div>}
      {quote && (
        <div className={css.msg}>
          {quote.quoteNumber} · {quote.quantity} units · ${quote.buyerPrice} total · valid until {new Date(quote.validUntil).toLocaleDateString()} · shipping {quote.shippingStatus}. Agent: {quote.agent?.name || '—'}.{' '}
          <NamedLink name="BuyerDashboardPage" params={{ tab: 'quotations' }}>
            View in quotations
          </NamedLink>
        </div>
      )}
    </section>
  );
};

export default GetAutomaticQuote;
